import React from 'react';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { handleOperationSubMenuChange } from '../helpers/operation';

type Props = {
    menuOperation: FilterOperationsT;
    setFilter: (fields: Partial<SentenceFilterT>) => void;
};

const SimpleFilterOperationSelector = ({ menuOperation, setFilter }: Props) => {
    const { t } = useTranslation('sentence');
    return (
        <MenuItem
            value={menuOperation}
            onClick={handleOperationSubMenuChange(menuOperation, setFilter)}
        >
            {t(`yearOperations.${menuOperation}`)}
        </MenuItem>
    );
};

export default React.memo(SimpleFilterOperationSelector);
